import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import UniqueId from 'vue-unique-id';
import reactiveStorage from "vue-reactive-storage";
import titleMixin from './mixins/titleMixin';
import browserDetect from "vue-browser-detect-plugin";

Vue.mixin(titleMixin);
Vue.use(UniqueId);
Vue.use(browserDetect);

Vue.use(reactiveStorage, {
  token: "",
  accessLevel: "",
  endDate: "",
  email: ""
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
